import t from"./actionTypes.js";function o(o,n,r,e={}){const i=t[r.type];if(i&&"function"==typeof i)return i(o,n,r,e);throw new Error("Invalid Action")}export{o as default,o as getComponentForAction};
//# sourceMappingURL=PaymentAction.js.map
